import pLimit from 'p-limit';

import type { AttachmentFile } from '@/services/ws-funnel/src/main/resources/rest-api';

import type { UploadFile } from './types';

export const limit = pLimit(5);

export const getFileContent = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = (error) => reject(error);
  });

export const convertFiles = async (files: UploadFile[]): Promise<AttachmentFile[]> => {
  const attachments = await Promise.all(
    files.map((file) =>
      limit(async () => {
        try {
          const content = (await getFileContent(file.file)).split(',')[1];
          if (!content) {
            throw new Error('conversion failed');
          }
          return {
            name: file.file.name,
            language: file.language,
            content,
          };
        } catch (e) {
          return null;
        }
      }),
    ),
  );
  return attachments.filter((file): file is AttachmentFile => !!file);
};
